import React from 'react'
import { FieldProps, getIn } from 'formik'

import { AdvancedAutocomplete } from 'civic-champs-shared'
import { CheckOutRole } from '../types'

interface CheckOutRoleFieldProps<FormValues = any> extends FieldProps<CheckOutRole, FormValues> {
  roles: CheckOutRole[]
}

export const CheckOutRoleField = ({ field, form, meta, roles, ...props }: CheckOutRoleFieldProps) => {
  const touched = getIn(form.touched, field.name)
  const error = getIn(form.errors, field.name)

  return (
    <AdvancedAutocomplete<CheckOutRole>
      {...props}
      options={roles}
      value={field.value}
      getOptionInfo={(option: CheckOutRole) => ({
        left: option.name,
        id: option.id,
      })}
      onChange={(option: CheckOutRole) => form.setFieldValue(field.name, option)}
      error={touched && error ? error : undefined}
    />
  )
}
